import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class ForgotPasswordService {

  constructor(private http: HttpClient) { }


  forgotPasswordCheck(username: string, email: string, panel: string) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/Forgot/CheckForgotPassword', { username: username,email:email,panel:panel }, { headers: Headers });
  }

  checkLink(panel: string, linkCode:string) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.get(globalAdd.Paneladdress + 'api/Forgot/checkLink?panel='+panel+'&linkCode='+linkCode, { headers: Headers });
  }

  changeForgotPassword(newPassword,linkCode, panel) {
    var Headers = new HttpHeaders({  'No-Auth': 'True' });
    return this.http.post(globalAdd.Paneladdress + 'api/Forgot/ChangeForgotPassword', { newPassword: newPassword,linkCode: linkCode,panel: panel }, { headers: Headers });
  }

  getInvoiceInfo(transactionId: string) {
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.get(globalAdd.Paneladdress + 'api/MailInvoiceInfo/getInvoiceInfo?transactionId='+ transactionId , { headers: Headers });
  }

  getForgotUserNameList(email: string, panel: string){
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.get(globalAdd.Paneladdress + 'api/Forgot/getForgotUserNameList?email='+email+'&panel='+panel, { headers: Headers });
  }

  sendForgotUsername(id:string, panel:string){
    var Headers = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.get(globalAdd.Paneladdress + 'api/Forgot/sendForgotUsername?id='+id+'&panel='+ panel, { headers: Headers });
  }

}
